var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsAppicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.228,
    height: 45.228,
    viewBox: "0 0 45.228 45.228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    transform: "translate(1496.172 -5872.626)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_428",
    "data-name": "Ellipse 428",
    cx: 22.614,
    cy: 22.614,
    r: 22.614,
    transform: "translate(-1496.172 5872.626)",
    fill: "#444e7b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    transform: "translate(-1484.882 5883.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M14.18,107.626c.553-1.608,1.005-3.116,1.558-4.623a3.367,3.367,0,0,0-.1-2.864A11.581,11.581,0,1,1,28.5,106.822a11.073,11.073,0,0,1-7.387-.955,1.517,1.517,0,0,0-1.055-.1c-1.809.6-3.669,1.156-5.478,1.759a.619.619,0,0,0-.352.1Zm3.015-3.015a2.264,2.264,0,0,0,.4-.1c.955-.3,1.91-.6,2.864-.955a.82.82,0,0,1,.754.1,9.516,9.516,0,0,0,6.181,1.307,9.638,9.638,0,1,0-9.7-5.126,2.741,2.741,0,0,1,.2,2.764,10.485,10.485,0,0,0-.653,2.01Z",
    transform: "translate(-14.18 -83.886)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M24.2,96.561c-.251-.05-.653-.1-1.005-.2a11.254,11.254,0,0,1-6.332-4.824,7.234,7.234,0,0,1-1.407-3.166,3.339,3.339,0,0,1,1.055-2.915,1.332,1.332,0,0,1,2.161.352c.352.8.955,1.809.653,2.714-.151.452-.6.653-.754,1.106s.151.754.4,1.106a7.9,7.9,0,0,0,3.216,2.814c.452.2.754.251,1.106-.2.2-.3.5-.553.754-.854.2-.2.4-.3.653-.151.8.4,1.608.8,2.362,1.256a.637.637,0,0,1,.2.452,2.431,2.431,0,0,1-2.111,2.412,2.791,2.791,0,0,0-.854.1Z",
    transform: "translate(-9.173 -79.203)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsAppicon);
export default __webpack_public_path__ + "static/media/whatsAppicon.0874aedef7465a5f2dc1e5f0edb17878.svg";
export { ForwardRef as ReactComponent };